'use client'

import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useEffect, useState } from 'react'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import PropTypes from 'prop-types'

export const OrganisationSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required,
  errors = {}
}) => {
  const pageSize = 25
  const { fetchOrganisationsBySearchTerm } = useLookupsStore()
  const [options, setOptions] = useState(testData || [])
  const [totalRowCount, setTotalRowCount] = useState(pageSize)
  const [startAtIndex, setStartAtIndex] = useState(0)
  const [selectedValue, setSelectedValue] = useState(value)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    if (testData) return

    const fetchOrganisations = async () => {
      if (totalRowCount > options?.length) {
        const { rows, totalRowCount } = await fetchOrganisationsBySearchTerm({ startAtIndex, pageSize, searchTerm })
        setOptions([...options, ...rows])
        setTotalRowCount(totalRowCount)
      }
    }

    fetchOrganisations()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, fetchOrganisationsBySearchTerm, startAtIndex, totalRowCount, searchTerm])

  useEffect(() => {
    setSelectedValue(value)
  }, [value])

  useEffect(() => {
    setStartAtIndex(0)
  }, [searchTerm])

  const handlePagination = () => {
    setStartAtIndex(startAtIndex + pageSize)
  }

  return (
    <div data-testid="OrganisationSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label="Organisation"
        onChange={(newVal) => {
          onChange(newVal)
          setSelectedValue(newVal)
        }}
        labelKey="name"
        valueKey="organisationId"
        items={options}
        value={selectedValue}
        searchable
        idLabelKey="organisationId"
        showIdInResults={false}
        name="organisationId"
        size={size}
        required={required}
        errors={errors}
        onAtBottom={handlePagination}
        onSearchTermChange={setSearchTerm}
        menuZindex={9999999}
      />
    </div>
  )
}

OrganisationSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.object
}
